import icon1 from '../../../assets/choose/smartIcon.png'
import icon2 from '../../../assets/choose/certifiedIcon.png'
import icon3 from '../../../assets/choose/supportIcon.png'

export const chooseData = [
  {
    title: "Smart Solutions",
    icon: icon1,
    des: "Sollicitudin massa maecenas purus adipiscing egestas natoque fringilla odio ac sodales"
  },
  {
    title: "Certified Expert",
    icon: icon2,
    des: "Sollicitudin massa maecenas purus adipiscing egestas natoque fringilla odio ac sodales"
  },
  {
    title: "24/7 Support",
    icon: icon3,
    des: "Sollicitudin massa maecenas purus adipiscing egestas natoque fringilla odio ac sodales"
  },
]